import React from 'react';
import { WidgetProps } from '@wix/yoshi-flow-editor';

import { SocialGroupsApp } from 'common/components/SocialGroupsApp';

import { COMPONENT } from 'settings/consts';

import type { IControllerProps } from 'controller/types';

import { Widget } from './Widget';

COMPONENT.name = 'FeedWidget';

function FeedWidget(props: WidgetProps<IControllerProps>) {
  return (
    <SocialGroupsApp {...props}>
      <Widget />
    </SocialGroupsApp>
  );
}

FeedWidget.displayName = 'FeedWidget';

export default FeedWidget;
